/** @file dock-manager/BufferBar.jsx — hatched turnaround strip after each booking card. */

/**
 * BufferBar renders a thin diagonal-hatched strip immediately after a booking
 * card, representing the `turnaround_minutes` the bay is unavailable for the
 * next driver. It's purely visual — the real enforcement lives in the
 * `lbs_bookings_enforce_site_rules` trigger (migration 150, Rule 7).
 *
 * Returns null for 0-minute buffers so BayRow can call this blindly without
 * guards.
 */
export default function BufferBar({
  booking,
  bufferMinutes,
  windowStart,
  windowEnd,
  pxPerHour,
}) {
  if (!bufferMinutes || bufferMinutes <= 0) return null;

  const end = new Date(booking.scheduled_end);
  const bufEnd = new Date(end.getTime() + bufferMinutes * 60 * 1000);

  // Entire buffer is before/after the visible window → draw nothing.
  if (bufEnd <= windowStart || end >= windowEnd) return null;

  const visStart = end < windowStart ? windowStart : end;
  const visEnd = bufEnd > windowEnd ? windowEnd : bufEnd;
  const leftHours = (visStart - windowStart) / 3600 / 1000;
  const widthHours = Math.max(0.1, (visEnd - visStart) / 3600 / 1000);

  return (
    <div
      data-testid={`buffer-bar-${booking.id}`}
      title={`Turnaround — ${bufferMinutes} min`}
      aria-label={`Turnaround buffer ${bufferMinutes} minutes`}
      className="absolute top-1.5 bottom-1.5 pointer-events-none rounded-sm"
      style={{
        left: leftHours * pxPerHour,
        width: widthHours * pxPerHour - 1,
        backgroundImage:
          "repeating-linear-gradient(135deg, rgba(100,116,139,0.35) 0 4px, transparent 4px 8px)",
        border: "1px dashed rgba(100,116,139,0.5)",
        backgroundColor: "rgba(226,232,240,0.4)",
      }}
    />
  );
}
